export default "__VITE_ASSET__IooFAxGm__"